import { i18n } from "translate/i18n";

export const title = i18n.t("messages.notifications.push.title");
export const body = i18n.t("messages.notifications.push.body");
